import styled, { css } from 'styled-components';

//style: solid, dashed, double

const themes = {
  1: {
    color: 'var(--color-grey-10_10)',
    style: 'solid',
  },
};

const sizes = {
  s: {
    thickness: '1px',
    padding: '2px 12px',
  },
};

export const Container = styled.div`
  --color-bkg: ${(p) => (themes[p.theme] || themes['1']).color};
  --thickness: ${(p) => (sizes[p.size] || sizes['s']).thickness};
  --padding: ${(p) => (sizes[p.size] || sizes['s']).padding};
  --border-style: ${(p) => (themes[p.theme] || themes['1']).style};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--padding);
`;

const baseStyles = css`
  ${({ length }) => length && `width: ${length};`}
`;

export const HorizontalDivider = styled.div`
  ${baseStyles}
  height: var(--thickness);
  width: ${({ length }) => length || '100%'};
  border-top: var(--thickness) var(--border-style) var(--color-bkg);
`;

export const VerticalDivider = styled.div`
  ${baseStyles}
  height: ${({ length }) => length || '100%'};
  width: var(--thickness);
  border-left: var(--thickness) var(--border-style) var(--color-bkg);
`;
